export const REDIRECTED_USER = "redirectedUser";
export const CHECK_AUTH = "checkAuth";
export const LOAD_ITEMS = "loadItems";
export const NEW_CANVAS_USER = 'newCanvasUser';
export const LOGIN_USER_CANVAS = 'loginCanvasUserSession'
export const REGISTER_EXISTING ='enrollUserToNewCourse'
export const LOG_USER_OUT = 'loggingUserOut'
export const EMAIL_VALIDATION = 'checkingExistinEmail'